<script>
import RightLayout from '@/router/layouts/rightLayout'
import dialog from '@/components/Dialog'
export default {
  components: { RightLayout, 'v-dialog': dialog },
  data () {
    return {
      name: this.$route.query.name,
      deadLine: this.$route.query.deadLine,
      pdfDate: '',
      uid: this.$route.query.uid,
      driver: Object,
      imgType: '',
      incrementNo: '',
      // 出力Dialog
      showPrintDialog: false,
      dialogPrintOption: {
        showNo: true,
        text: 'データをダウンロードします。<br/>よろしいですか？',
        cancelButtonText: 'キャンセル',
        confirmButtonText: '実行'
      },
      serviceName: '',
      organizationAddress: '',
      organizationName: '',
      organizationRepresentative: '',
      organizationContact: ''
    }
  },
  created () {
    this.$axios.get('driver/queryDriverByUid', {params: {uid: this.uid}}).then(response => {
      this.driver = response.data.driverInfo
      if (this.driver.facePhotoUrl) {
        this.imgType = this.driver.facePhotoUrl.substring(this.driver.facePhotoUrl.lastIndexOf('.') + 1, this.driver.facePhotoUrl.length)
      }
      this.pdfDate = response.data.nowTime
    }).catch(error => {
      console.log(error)
    })
    this.$axios.get('driver/getDriverCardInfo').then(response => {
      console.log('driver/getDriverCardInfo')
      console.log(response)
      let driverCardInfo = response.data.driverCardInfo
      this.serviceName = driverCardInfo.serviceName
      this.organizationAddress = driverCardInfo.organizationAddress
      this.organizationName = driverCardInfo.organizationName
      this.organizationRepresentative = driverCardInfo.organizationRepresentative
      this.organizationContact = driverCardInfo.organizationContact

    }).catch(error => {
      console.log(error)
    })
  },
  methods: {
    cancel () {
      this.$router.push({name: 'DriverList'})
    },
    getMyPdf (pdfDom, pdfName, imgType) {
      this.dialogPrintOption.text = 'データをダウンロードします。<br/>よろしいですか？'
      this.dialogPrintOption.showNo = true
      this.dialogPrintOption.cancelButtonText = 'キャンセル'
      this.dialogPrintOption.confirmButtonText = '実行'

      this.showPrintDialog = true
      this.$refs.printDialog.confirm().then(() => {
        this.showPrintDialog = false
        this.getPdf(pdfDom, pdfName, imgType)
      })
        .catch(() => {
          this.showPrintDialog = false
        })
      // this.$axios.get('driver/queryPdfIncrementNo').then(response => {
      //   this.incrementNo = response.data.incrementNo
      //   this.getPdf(pdfDom, pdfName, imgType)
      // }).catch(error => {
      //   console.log(error)
      // })
    }
  }
}
</script>

<template>
  <right-layout>
    <!-- header -->
    <div class="clearfix">
        <div class="col-md-12 column header F3-M-27">
            運転者証
        </div>
    </div>

    <div id="pdfDom" class="slider">
      <div id="pdf">
        <!-- head -->
        <div class="clearfix head">
          <div class="col-md-6 column head-right">
            <div class="img-div">
              <img style="height:100%;width:100%;" crossorigin="anonymous" :src="driver.facePhotoUrl?driver.facePhotoUrl+'?v=123456':''"/>
            </div>
          </div>
          <div class="col-md-6 column head-left">
            <table style="width:400px">
              <tbody>
                <tr>
                  <td style="border-right:1px solid #000;border-bottom:1px solid #000;font-size:20px;">
                    作成番号
                  </td>
                  <td style="border-left:1px solid #000;border-bottom:1px solid #000;font-size:20px;">
                    {{driver.loginId}}
                  </td>
                </tr>
                <tr>
                  <td style="border-right:1px solid #000;border-top:1px solid #000;font-size:20px;">
                    作成年月日
                  </td>
                  <td style="border-left:1px solid #000;border-top:1px solid #000;font-size:20px;">
                    {{pdfDate}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- body -->
        <div class="clearfix body">
          <div class="col-md-12 column body-head"><span style="margin-right:40px;">運</span><span style="margin-right:40px;">転</span><span style="margin-right:40px;">者</span><span>証</span></div>
          <div class="col-md-12 column">
            <table style="width:100%">
              <tbody>
                <tr class="body-tr">
                  <td class="body-td-key" style="border-right:1px solid #000;border-bottom:1px solid #000;">
                    自家用有償旅客運送者の名称
                  </td>
                  <td class="body-td-value" style="border-left:1px solid #000;border-bottom:1px solid #000;">
                    {{serviceName}}
                  </td>
                </tr>
                <tr class="body-tr">
                  <td class="body-td-key" style="border-right:1px solid #000;border-bottom:1px solid #000;border-top:1px solid #000;">
                   運転者の氏名
                  </td>
                  <td class="body-td-value" style="border-left:1px solid #000;border-bottom:1px solid #000;border-top:1px solid #000;">
                    {{driver.lastName}}&nbsp;{{driver.firstName}}
                  </td>
                </tr>
                <tr class="body-tr">
                  <td class="body-td-key" style="border-right:1px solid #000;border-bottom:1px solid #000;border-top:1px solid #000;">
                    運転免許証の有効期限
                  </td>
                  <td class="body-td-value" style="border-left:1px solid #000;border-bottom:1px solid #000;border-top:1px solid #000;">
                    {{driver.driverLicenseDeadline}}
                  </td>
                </tr>
                <tr class="body-tr">
                  <td class="body-td-key" style="border-right:1px solid #000;border-top:1px solid #000;">
                    道路運送法施行規則第51条の16第1項に掲げる要件
                  </td>
                  <td class="body-td-value" style="border-left:1px solid #000;border-top:1px solid #000;">
                    第1種運転免許（国土交通大臣が認定する講習を受講済）
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- foot -->
        <div class="clearfix foot">
          <div class="col-md-6 column">
          </div>
          <div class="col-md-6 column">
            <p>団体の長の証明印</p>
            <p>{{organizationAddress}}</p>
            <p>{{organizationName}}</p>
            <p><span class="name-span" >{{organizationRepresentative}}</span>印</p>
            <p>{{organizationContact}}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <div class="card-footer">
      <div class="col-md-6 column">
          <button class="driver-card-button" style="float:right" @click="getMyPdf('#pdf','運転者証',imgType)">プリント</button>
      </div>
      <div class="col-md-6 column">
          <button class="driver-card-button" style="float:left" @click="cancel">キャンセル</button>
      </div>
    </div>
    <v-dialog v-show="showPrintDialog" :dialog-option="dialogPrintOption" ref="printDialog"></v-dialog>
  </right-layout>
</template>

<style scss scoped>
  .header{
    padding-top: 18px;
    padding-bottom: 18px;
  }
  #pdfDom{
    background-color:#fff;
    width: 1100px;
    flex: 8;
    display: flex;
    align-self: center;
    border: 1px solid #000;
  }
  #pdf{
    height: 841.89px;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-left: 120px;
    padding-right: 120px;
    color: #000;
  }
  .head{
    display: flex;
    flex: 2;
    margin-top: 100px;

  }
  .head-right{
    display: flex;
    align-items: center;
  }
  .head-left{
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .img-div{
    /* border: 2px dashed #000; */
    height: 100px;
    width: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }

  td{
    border: 2px solid #000;
    width: 50%;
  }
  .body{
    display: flex;
    flex-direction: column;
  }

  .body-head{
    font-size: 30px;
  }

  .body-tr{
    height: 65px;
  }
  .body-td-key{
    text-align: left;
    width: 42%;
    padding-left: 10px;
    padding-right: 30px;
    font-size: 22px;
  }
  .body-td-value{
    width: 58%;
    font-size: 18px;
  }
  .foot{
    display: flex;
    margin-top: 30px;
  }
  p{
    text-align: left;
    font-size: 20px;
    margin: 0px;
  }
  .name-span{
    font-size:25px;
    margin-right:100px
  }
  .card-footer{
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 2;
  }
  .driver-card-button{
  width: 65%;
  height: 55px;
  border-radius: 10px;
  /* margin: 30px; */
  font-size: 22px;
  color: #fff;
  border: 0px;
  background:linear-gradient(rgb(112, 182, 202) 50%, rgb(72,163,190) 50%);
}
</style>



// WEBPACK FOOTER //
// src/router/views/DriverCard.vue